import script from "./PortalFormDetailCard.vue?vue&type=script&setup=true&lang=js"
export * from "./PortalFormDetailCard.vue?vue&type=script&setup=true&lang=js"

import "./PortalFormDetailCard.vue?vue&type=style&index=0&id=e32c3538&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e32c3538"]])

export default __exports__